/**
 * @file store state
 * @author wangzhongpeng
 */

export default {
  rawRegionList: [],
  user: null
};
